import { Abonent } from '@shared/types/osi/abonents';
// OSI-808: тип строки итогов, закреплённой снизу грида ОСВ
import { type OsvTotalRow } from '@shared/utils/helpers/osvTotalRows';

export interface IOsiOsvWidgetViewModel {
  isLoading: boolean;
  loadOsv: () => Promise<void>;
  downloadOsv: () => Promise<void>;
  sortedAbonents: Abonent[];
  abonentsCount: number;
  totalsOsv: any[];
  // OSI-808: строки итогов («ИТОГО» + категории услуг) для пропа totalRows у OsvGrid.
  // Отдельно от totalsOsv: тот — плоский массив чисел для футера под таблицей,
  // этот — строки грида; заказчику нужны оба способа отображения одновременно.
  osvTotalRows: OsvTotalRow[];
  dateFieldValue: any;
  // Флаг «Свернуть дочерние помещения» и его сеттер
  isCollapseChildren: boolean;
  setCollapseChildren: (value: boolean) => void;
  // OSI-806: есть ли у ОСИ дочерние помещения (паркинги/кладовки).
  // Если нет — чекбокс «Свернуть дочерние помещения» не показываем.
  hasChildAbonents: boolean;
}

export const IOsiOsvWidgetViewModelToken = Symbol.for('IOsiOsvWidgetViewModel');
